import * as React from 'react';
import { Switch, Route, Redirect } from 'react-router';
import { IRouterConfig } from 'routes/router.config';
import Authorized from 'components/Authorized';

function formatMatter(config: IRouterConfig[]) {
  return (
    <Switch>
      {config.map((item: IRouterConfig) => {
        let childRoute: any;
        const ViewComponent = item.component;
        if (item.redirect) {
          return <Redirect exact={true} key={item.name} from={item.path} to={item.redirect} />;
        }

        // 嵌套路由
        if (item.routes && item.routes.length) {
          childRoute = (
            <Route key={item.name} path={item.path}>
              <ViewComponent key={item.name}>{formatMatter(item.routes!)}</ViewComponent>
            </Route>
          );
        } else {
          childRoute = (
            <Route key={item.name} path={item.path} exact={item.exact}>
              <ViewComponent key={item.name} />
            </Route>
          );
        }

        // 权限校验
        if (item.authority && item.authority.length) {
          return (
            <Route key={item.name} exact={item.exact} path={item.path}>
              <Authorized key={item.name} isPage={true} authority={item.authority!}>
                {childRoute}
              </Authorized>
            </Route>
          );
        }
        return childRoute;
      })}
    </Switch>
  );
}

export default function generateRouter(config: IRouterConfig[]) {
  return formatMatter(config);
}
